import { render, staticRenderFns } from "./CopyToClipboardButton.vue?vue&type=template&id=7fadba88&scoped=true&"
import script from "./CopyToClipboardButton.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fadba88",
  null
  
)

export default component.exports